import InputField from "../../UI/Inputs/InputField";
import Button from "../../UI/Button";
import { useRef } from "react";
import { SignPropsType } from "../../../pages/Sign/utils";
import style from "../../../pages/Sign/index.module.css";
import { useTranslation } from "../../../hooks/useTranslation";

const ChangeForgottenPassword = ({
  register,
  setActivePage,
  watch,
  errors,
  isSubmitting,
  submitSuccess,
}: SignPropsType) => {
  const { locale } = useTranslation();
  const password = useRef({});
  password.current = watch?.("forget_password");

  return submitSuccess ? (
    <div className={style.form_ctas}>
      <Button
        styleType="primary_black"
        buttonType="button"
        extraProps={{ style: { maxWidth: "250px" } }}
        onClick={() => setActivePage?.("signin")}
      >
        {locale("login")}
      </Button>
    </div>
  ) : (
    <>
      <InputField
        label={locale("new_password")}
        placeholder={locale("new_password")}
        type="password"
        extraProps={register("forget_password")}
      />
      <InputField
        label={locale("confirm_password")}
        placeholder={locale("confirm_password")}
        type="password"
        extraProps={register("forget_confirm_password", {
          validate: (value) => value === password.current || locale("passwords_dont_match"),
        })}
        error={errors?.forget_confirm_password ? errors.forget_confirm_password.message : ""}
      />
      <div className={style.forget_link} style={{ marginTop: 0 }}>
        <button type="button" onClick={() => setActivePage?.("signin")}>
          {locale("remember_password")}
          {locale("questionMark")}
        </button>
      </div>
      <div className={style.form_ctas}>
        <Button
          styleType="primary_black"
          buttonType="submit"
          extraProps={{ style: { maxWidth: "250px" } }}
          disabled={isSubmitting}
          isLoading={isSubmitting}
        >
          {locale("submit")}
        </Button>
      </div>
    </>
  );
};

export default ChangeForgottenPassword;
